import { Bot, User } from 'lucide-react';
import { SegmentedControl, type SegmentedOption } from '../shared/SegmentedControl';
import type { AccountTypeLocal } from '../../api/types/TenantLocal';

const OPTIONS: SegmentedOption<AccountTypeLocal>[] = [
    { value: 'HUMAN', label: 'Persona', Icon: User },
    { value: 'API', label: 'Sistema (API)', Icon: Bot },
];

interface Props {
    value: AccountTypeLocal;
    onChange: (value: AccountTypeLocal) => void;
    idPrefix: string;
}

/** Selector Persona / Sistema (API) del alta de usuario. */
export function AccountTypeSelector({ value, onChange, idPrefix }: Props) {
    return (
        <SegmentedControl
            legend="Tipo de usuario"
            name={`${idPrefix}-account-type`}
            value={value}
            options={OPTIONS}
            onChange={onChange}
        />
    );
}
